import { render, staticRenderFns } from "./company.vue?vue&type=template&id=6ca51be2&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca51be2",
  null
  
)

export default component.exports